import { PropsWithChildren } from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";

import { getAuthToken } from "../../auth/utils/helpers";
import { authRoutesConstants } from "modules/auth/routes/routesConstants";

const PrivateRoute = ({ children, ...rest }: PropsWithChildren<RouteProps>) => {
  const authToken = getAuthToken();

  const isAuthenticated = Boolean(authToken);

  return (
    <Route
      {...rest}
      render={() =>
        isAuthenticated ? (
          <>{children}</>
        ) : (
          <Redirect
            to={authRoutesConstants.login.href(
              window.location.pathname + window.location.search
            )}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
